import React, {Fragment} from 'react';
import {Breadcrumb, ScrollTopBtn, Seo} from '../components';
import {ContactTwo, FooterOne, HeaderOneCopy} from '../containers';

const EInvoicingRiskAssistant = () => (
  <Fragment>
    <Seo title="E-Invoicing Risk Assessment" />
    <HeaderOneCopy />
    <Breadcrumb pageName="E-INVOICING RISK ASSESSMENT"
                pageSubTitle={"Comprehensive Risk Analysis"}
                pageDesc={"Identify and mitigate potential risks in your e-invoicing implementation."}
                bgImage="images/bg/bg-image-6.png" />
    <ContactTwo initialService={"E-Invoicing Risk Assessment"} className="space-top space-extra-bottom"/>
    <FooterOne/>
    <ScrollTopBtn/>
  </Fragment>
);

export default EInvoicingRiskAssistant;